const SimplifiedDiv = ({ style, children }) => (
  <div style={style}>{children}</div>
);

export default SimplifiedDiv;
